// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1955":"c72176c1","4628":"9e7a6797","6019":"c72176c1","6391":"c72176c1","6874":"c72176c1","7192":"c72176c1","7653":"b48cb014","7723":"fdc05dbf","9224":"c72176c1"}[chunkId] + ".chunk.css";
};